import axios from "axios";

let META_LIST_JSON = (async function () {
  META_LIST_JSON = await loadMetaList();
})();

function loadMetaList() {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get('https://gangstabet-assets.s3.us-east-1.amazonaws.com/ipfs/list/index.json');
      META_LIST_JSON = res.data;

      resolve(META_LIST_JSON);
    } catch (e) {
      resolve({});
    }
  });
}

export const getMetadataForId = async (meta_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      resolve(META_LIST_JSON[meta_id]);
    } catch (e) {
      resolve();
    }
  });
};
